import { render, staticRenderFns } from "./dialog-logs.vue?vue&type=template&id=c5b13c4a"
import script from "./dialog-logs.vue?vue&type=script&lang=js"
export * from "./dialog-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports